import $ from "jquery";

export function notifySuccess(message) {
  $.notify(message, {
    className: "success"
  });
}

export function notifyFailure(error, message) {
  console.error(message + ": " + error);
  $.notify(message, {
    className: "error"
  });
}
